import { Errors } from 'gleblu-socket-api';
import { createAction } from 'redux-act';

export interface ResetPasswordPayload {
  token: string;
  newPassword: string;
}
export const resetPassword = createAction<ResetPasswordPayload>('RESET_PASSWORD');

export const passwordReset = createAction<object>('PASSWORD_RESET');

export interface PasswordResetFailedPayload {
  errorType?: Errors;
}
export const passwordResetFailed = createAction<PasswordResetFailedPayload>('PASSWORD_RESET_FAILED');
